/* 登录状态 */
export default {

    /*验证是否登录*/
    /**
     * 在main.js中使用
     *
    router.beforeEach((to, from, next) = > {
        LoginStatus.check({
            type: 'wechatOauth',
            redirectUrl: '/api/wechat/auth'
        }, next);
    })
     * */
    check: function(option, next) {
        let that = this;
        option = option || {};
        let data = {
            type: option.type || 'wechatOauth', // wechatOauth:微信授权; login:普通登录
            isRedirect: option.isRedirect || 1, //1 or 0
            redirectUrl: option.redirectUrl || '/', //bind_wechat
            url: option.url || location.pathname, //需要验证的地址
            callbackUrl: option.callbackUrl || location.pathname + location.search //返回的地址
        };

        // debugger
        // 默认回调地址如果是登录页的话就设置回调地址为分销个人中心
        if (decodeURIComponent(decodeURIComponent(option.callbackUrl)) == data.url && data.url == '/login') {
            data.callbackUrl = '/distribution/personal/index';
        }
        //没有签名
        if (tools.isEmpty(tools.cache.get('Authorization')) && window.canauthinit == 1) {
            that.getSign(option, next);
        } else if (!tools.isEmpty(tools.cache.get('Authorization'))) {
            if (tools.url.params('usertest') && config.environment === 'debug') { // 使用测试账号或处于调试模式
                next();
                return;
            }
            if (tools.cache.get('is_wechat_login') == 1) {  // 微信登录
                //is_wechat_login  1用微信登录，2微信正在登录中
                tools.cache.set('is_wechat_login', 2);
                var callback = location.origin + data.callbackUrl;
                console.log('================cb: ', callback);
                var share_from = '';
                if (tools.url.params('share_from') !== undefined && !isNaN(tools.url.params('share_from'))) {
                    share_from = '&share_from=' + tools.url.params('share_from');
                }
                var url = window.config.api.url + data.redirectUrl +
                    '?callback=' + (encodeURIComponent(callback)) +
                    '&token=' + (tools.cache.get('Authorization')) +
                    '&type=' + 'mp' + share_from;

                if (!tools.isEmpty(tools.url.params('testuser'))) {
                    url += '&testuser=' + tools.url.params('testuser');
                }

                tools.cache.set('isLogin', 2);

                console.log('url: ', url);
                window.location.href = url;
            } else if (tools.cache.get('is_wechat_login') == 2 && tools.cache.get('isLogin') == 2) {
                //请求是否登录
                that.isLogin('/api/islogins', option, next);
            } else if (tools.cache.get('isLogin') == 0 || tools.cache.get('isLogin') == undefined) {//判断是否已登录(没登录或初次)
                if (tools.noLoginUrl.isUrl(data.url)) {
                    //debugger
                    if (typeof next == 'function') {
                        next();
                    }
                } else if ((data.url.toLowerCase() == '/distribution/chat' || data.url.toLowerCase() == '/college/index') && !!tools.url.params('token')) {
                    if (typeof next == 'function') {
                        next();
                    }
                } else if (data.type == 'wechatOauth') {
                    // debugger
                    var callback = location.origin + data.callbackUrl;
                    if (tools.cache.get('isAuth') == 1) {
                        // tools.router.push({path: '/login', query: {callback: callback}});

                        //判断授权后，需要登录的时候先去游客模式
                        if (!tools.noLoginUrl.isUrl(option.url)) {
                            if (!!next) {
                                next({ 'path': '/tourists/index', query: {} });
                            } else {
                                tools.router.replace({ 'path': '/tourists/index', query: {} });
                            }
                        } else if (next != undefined) {
                            next();
                        } else {
                            tools.router.push({ path: option.callbackUrl });
                        }
                        return;
                    }
                    var share_from = '';
                    if (tools.url.params('share_from') !== undefined && !isNaN(tools.url.params('share_from'))) {
                        share_from = '&share_from=' + tools.url.params('share_from');
                    }
                    console.log('+++++++++++++++++callback: ', callback)
                    var url = window.config.api.url + data.redirectUrl +
                        '?callback=' + (encodeURIComponent(callback)) +
                        '&token=' + (tools.cache.get('Authorization')) +
                        '&type=' + 'mp' + share_from;

                    if (!tools.isEmpty(tools.url.params('testuser'))) {
                        url += '&testuser=' + tools.url.params('testuser');
                    }

                    tools.cache.set('isLogin', 2);
                    console.log('url: ', url)
                    window.location.href = url;
                } else if (data.type == 'login') {
                    //请求是否登录
                    console.log(11111);

                    that.isLogin('/api/islogins', option, next);
                }
                return false
            }
            //授权中
            else if (tools.cache.get('isLogin') == 2) {
                //请求是否登录
                that.isLogin('/api/islogins', option, next);
            }
            //通过
            else {
                that.authPath(option, next);
            }
        }
    },

    authPath: function(option, next) {

        let is_dealer = localStorage.isDealer,
            // tools.cache.get('isDealer'),
            is_user = tools.cache.get('isUser'),
            parent = tools.cache.get('parent'),
            level_id = Number(JSON.parse(tools.cache.get('loginData')).level_id),
            is_perfect = tools.cache.get('isPerfect'),
            need_active = tools.cache.get('needActive');
        let dealer0_path = /(^\/distribution\/(identityauth|register|chat|goodsdetail))/i, //零售用户能进的
            dealer1_canpath = /(^\/retail\/(cart|info|(personal\/(?!.*?index))))/i, //代理商能进的页面
            dealer1_path = /(^((\/index)|(\/bind_wechat)|(\/$)|($)|(\/(\?))|\/goodsdetail|\/identityauth|(\/distribution\/(register|testgoods))|(\/retail\/)))/i, //代理商不能进的
            dealer2_path = /(^\/distribution\/(index|identityauth|improveidentity|personal|goodsdetail|wallet|stock|goodsorder|question|testgoods|materialorder|chat))/i; //会员能进的
        option.callbackUrl = decodeURIComponent(decodeURIComponent(option.callbackUrl));

        if (is_user == 0 && option.url == '/goodsdetail_share') {
            next();
            return
        }
        if (is_user == 1 && option.url == '/goodsdetail_share') {
            if (tools.url.params('jump') == 1) {
                next();
                return;
            }
            const goods_id = tools.url.params('goods_id'),
                oneself_id = JSON.parse(tools.cache.get('loginData')).user_id,
                parent_user_id = JSON.parse(tools.cache.get('loginData')).parent_user_id;
            if (level_id >= 2) {
                next();
                window.location.href = location.origin + '/goodsdetail_share?goods_id=' + goods_id + '&share_from=' + oneself_id + '&jump=1'
            } else {
                if (parent != 0) {
                    window.location.href = location.origin + '/goodsdetail_share?goods_id=' + goods_id + '&share_from=' + parent_user_id + '&jump=1'
                } else {
                    next();
                }
                return;
            }
        }

        if (/^\/distribution\/chat/i.test(option.callbackUrl)) {
            next();
            return;
        }
        if (/^\/goodsdetail_share/i.test(option.callbackUrl)) {
            next();
            return;
        }
        if (/^\/bind_wechat/i.test(option.callbackUrl)) {
            if (is_user == 0) {
                next();
                return;
            }
        }
        if (/^\/register/i.test(option.callbackUrl)) {
            if (typeof next == 'function') {
                next();
                return;
            }
            if (is_user == 0) {
                next();
            }
            else if (is_dealer == 0 || is_dealer == 3) { //零售用户或上级未审核
                next();
            }
            else if (is_dealer == 1 || is_dealer == 2) { //代理商
                next({ path: '/distribution/personal/index', replace: true });
            }
            else if (typeof next == 'function') {
                next();
            }
        } else if (/^\/login/i.test(option.callbackUrl)) {
            next();
        } else {
            if (is_user == 0 && tools.cache.get('is_wechat_login') != 2) {
                // tools.router.replace({ path: '/bind_wechat', query: { callback: option.callbackUrl } });
                tools.router.replace({ path: '/login', query: { callback: option.callbackUrl } });
            }
            else if ((is_dealer == 0 || is_dealer == 3) && tools.cache.get('parent') == 1) { //有上级的零售用户，进入分销商城页面
                if (dealer0_path.test(option.callbackUrl)) { //有上级的零售用户，进入的分销商城页面
                    next();
                } else if (/^\/distribution/i.test(option.callbackUrl)) { //其它的分销商城页面不能进入
                    tools.router.replace({ path: '/retail/personal/index' });
                } else {
                    next();
                }
            }
            else if ((is_dealer == 0 || is_dealer == 3) && /^\/distribution/i.test(option.callbackUrl)) { //没上级的零售用户，不能进入分销商城页面

                tools.router.replace({ path: '/retail/personal/index' });
            }
            else if (tools.cache.get('parent') == 0 && /^\/yunindex/i.test(option.callbackUrl)) { //没上级的零售用户，不能进入云商城页面
                tools.router.replace({ path: '/index' });
            }
            else if (is_dealer == 1 && dealer1_canpath.test(option.callbackUrl)) { //代理商能进入的页面
                next();
            }
            else if (is_dealer == 2 && (dealer1_canpath.test(option.callbackUrl) || dealer1_path.test(option.callbackUrl))) {
                next();
            }
            else if (is_dealer == 2) {
                next();
            }
            else if (typeof next == 'function') {
                next();
            }
        }
    },

    /* 获取签名 */
    getSign: function(option, next, init) {
        var that = this;
        console.log('开始获取签名');
        window.canauthinit = 0;
        var token = tools.url.params('token');
        if (/(^\/distribution\/(chat))/i.test(option.callbackUrl) && token) {
            tools.cache.set('Authorization', token);
            // localStorage.Authorization = token;
            that.check(option, next);
            window.canauthinit = 1;
            // $('#weixin').remove();
        } else {
            tools.ajax({
                url: '/api/init',
                ajaxData: {},
                successFun: function(response) {
                    console.log('获取到签名:', response);
                    tools.cache.set('Authorization', response.token);
                    // localStorage.Authorization = response.token;
                    //重新check
                    if (init) {
                        that.checkLogin(option, next);
                    } else {
                        that.check(option, next);
                    }
                    window.canauthinit = 1;
                },
                errorFun: function(error) {
                    log.error('获取签名失败');
                    window.canauthinit = 1;
                },
                type: 'GET'
            });
        }
    },

    /* 获取是否登录 */
    isLogin: function(url, option, next) {
        var that = this;
        console.log('loginStatus获取是否登录');
        tools.ajax({
            url: url,
            ajaxData: {},
            successFun: function(res) {
                tools.cache.set('isUser', res.data.is_user);
                tools.cache.set('isDealer', res.data.is_dealer);
                localStorage.isDealer = res.data.is_dealer;
                tools.cache.set('isSubscribe', res.data.is_subscribe);
                tools.cache.set('mpQrcode', res.data.mp_qrcode);
                tools.cache.set('parent', res.data.parent);
                tools.cache.set('isPerfect', res.data.is_perfect);
                tools.cache.set('needActive', res.data.need_active);

                if (res.data.need_active == 1 && res.data.is_user == 1 && decodeURIComponent(decodeURIComponent(option.callbackUrl)) != '/bind_account') {  //登录后有旧账号需要合并
                    tools.router.push({ path: '/bind_account', query: {} });
                    return;
                }
                if (tools.noLoginUrl.isUrl(option.callbackUrl)) {
                    // debugger
                    if (typeof next == 'function') {
                        next();
                    }
                } else if ((option.callbackUrl.toLowerCase() == '/distribution/chat' || option.callbackUrl.toLowerCase() == '/college/index') && !!tools.url.params('token')) {
                    if (typeof next == 'function') {
                        next();
                    }
                } else if (option.type) {
                    // 可以直接访问的页面
                    var canAccessPath = /(^\/(register))/i;
                    if (canAccessPath.test(option.callbackUrl)) {
                        next();
                        return;
                    } else if (res.data.is_user == 0) { //跳过微信授权判断，未登录
                        tools.cache.set('isLogin', 0);
                        tools.cache.set('isAuth', 0);
                        if (tools.noLoginUrl.isUrl(option.url) || option.url == '/') {
                            tools.router.replace({ 'path': option.url == '/' ? '/tourists/index' : option.url, query: {} });
                        } else {
                            // tools.router.replace({ 'path': '/bind_wechat', query: { type: 2,is_wechat: 1 } });
                            if (option.url.indexOf('/distribution/activity/20220701/myTeam') != -1) {
                                let cb = option.callbackUrl,
                                    str = cb.substr(cb.indexOf('?') + 1),
                                    arr = str.split('&').map(s => ({ [s.split('=')[0]]: s.split('=')[1] })),
                                    user = arr.find(o => o.user_id);
                                tools.router.replace({ 'path': '/register', query: { share_from: user.user_id, callback: data.callbackUrl } });
                            }
                            else tools.router.replace({ 'path': '/login', query: { type: 2, is_wechat: 1, callback: option.callbackUrl } });
                        }
                    } else if (res.data.is_wechat_auth == 1 && res.data.is_user == 0) { //授权成功，未登录
                        tools.cache.set('isLogin', 0);
                        tools.cache.set('isAuth', 1);
                        // tools.router.replace({ 'path': '/bind_wechat', query: { type: 2,is_wechat: 1 } });
                        tools.router.replace({ 'path': '/login', query: { type: 2, is_wechat: 1, callback: option.callbackUrl } });
                    } else if (res.data.is_wechat_auth == 0 && res.data.is_user == 0) { //授权失败
                        tools.cache.set('isAuth', 0);
                        tools.cache.set('isLogin', 0);
                        //重新check
                        that.check(option, next);
                        return;
                    } else if (res.data.is_user == 1) { //已登录
                        tools.cache.set('isAuth', 1);
                        tools.cache.set('isLogin', 1);

                        if (option.url == '/login') {
                            var cburl = tools.url.params('callback');
                            if (res.data.is_dealer == 0) {
                                tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/retail/personal/index') });
                            } else {
                                tools.router.replace({ 'path': (cburl ? decodeURIComponent(decodeURIComponent(cburl)) : '/distribution/personal/index') });
                            }
                        } else {
                            that.authPath(option, next);
                        }

                    }
                }
            },
            errorFun: function(error) {
                log.error('登录失败!');
                tools.alert.error('登录失败!');
                tools.cache.set('isLogin', 0);
                tools.cache.set('isAuth', 0);
                tools.cache.set('isUser', '');
                tools.cache.set('username', '');
                tools.cache.set('userId', '');
                tools.cache.set('isDealer', '');
                tools.cache.set('isPerfect', '');
                tools.cache.set('parent', '');
                tools.cache.set('loginState', '');
                tools.cache.set('is_wechat_login', '');
                tools.cache.set('needActive', '');
                // tools.cache.set('Authorization', '');
                tools.cache.set('level', '');
                localStorage.Authorization = '';
                localStorage.isLogin = '';
                localStorage.isDealer = '';
                //重新check
                that.check(option, next);
            },
            type: 'GET'
        });
    },

    isLoginFn: function() {
        return new Promise(resolve => {
            tools.ajax({
                url: '/api/islogins',
                ajaxData: {},
                type: 'GET',
                successFun: (resp) => {
                    resolve(resp);
                },
                errorFun: (error_data, status, headers, error_obj) => {
                    log.error('登录失败!');
                    tools.alert.error('登录失败!');
                    tools.cache.set('isLogin', 0);
                    tools.cache.set('isAuth', 0);
                    tools.cache.set('isUser', '');
                    tools.cache.set('username', '');
                    tools.cache.set('userId', '');
                    tools.cache.set('isDealer', '');
                    tools.cache.set('isPerfect', '');
                    tools.cache.set('parent', '');
                    tools.cache.set('loginState', '');
                    tools.cache.set('is_wechat_login', '');
                    tools.cache.set('level', '');
                    tools.cache.set('needActive', '');
                    localStorage.isLogin = '';
                    localStorage.isDealer = '';
                    resolve(false);
                }
            });
        });
    },

    // 每次跳转页面之前先请求数据进行部分判断
    checkLogin: async function(option, next) {
        const that = this;

        if (tools.isEmpty(tools.cache.get('Authorization')) && window.canauthinit == 1) {
            that.getSign(option, next, 1);
            return;
        }
        const res = await this.isLoginFn();

        if (!res || !res.data) {
            if (option.url !== '/login') {
                next('/login');
            } else {
                next();
            }
            return;
        }

        if (!res.data.site_enable) {
            if (!option.to || (option.to && option.to.query.code !== 'ZJw6304oFIMabqKC' && tools.cache.get('code') !== 'ZJw6304oFIMabqKC')) {
                if (option.url !== '/update') {
                    next({ path: '/update' });
                } else {
                    next();
                }
                return;
            }
            tools.cache.set('code', 'ZJw6304oFIMabqKC');
        }

        if (option.url === '/login') {
            next();
            return;
        }

        tools.cache.set('loginData', JSON.stringify(res.data));
        tools.cache.set('isUser', res.data.is_user);
        tools.cache.set('isDealer', res.data.is_dealer);
        tools.cache.set('isSubscribe', res.data.is_subscribe);
        tools.cache.set('mpQrcode', res.data.mp_qrcode);
        tools.cache.set('parent', res.data.parent);
        tools.cache.set('isPerfect', res.data.is_perfect);
        tools.cache.set('isAuth', res.data.is_wechat_auth);
        tools.cache.set('needActive', res.data.need_active); //是否需要绑定旧账号

        // 是否是繁体字
        if (res.data.typeface == 2) {
            tools.cache.set('is_traditional', 1);
        }
        if (tools.noLoginUrl.isUrl(option.url)) {  //不需要登录的页面
            const authPaths = [
                '/retail/special/details',
                '/distribution/wallet/qrcode',
                '/distribution/shoporder/qrcode',
                '/register',
                '/retail/special/details'
            ]
            //需要授权才能进入的页面
            if (authPaths.includes(option.url) && res.data.is_wechat_auth == 0) {
                tools.cache.set('is_wechat_login', 1);
                if (option.url == "/distribution/wallet/qrcode" || option.url == "/distribution/shoporder/qrcode") {
                    option.redirectUrl = '/api/wechat/pay/auth'
                }
                that.check(option, next);
            } else { //不需要授权就直接进入非登录页面
                if (!!next) {
                    next();
                } else {    //没有跳转默认跳转到登录
                    tools.router.replace({ path: '/login', query: { callback: option.callbackUrl } });
                }
            }
        } else if ((option.callbackUrl.toLowerCase() == '/distribution/chat' || option.callbackUrl.toLowerCase() == '/college/index') && !!tools.url.params('token')) {
            // 如果是客服页面或者直播间页面就直接获取带过来的token打开客服
            if (!!next) {
                next();
            }
        } else if (option.type) {
            if (res.data.is_user == 1) { //已登录
                tools.cache.set('isAuth', 1);
                tools.cache.set('isLogin', 1);
                if (res.data.need_active == 1 && decodeURIComponent(decodeURIComponent(option.callbackUrl)) != '/bind_account') {  //登录后有旧账号需要合并
                    if (!!next) {
                        next({ path: '/bind_account', query: {} });
                    } else {
                        tools.router.push({ path: '/bind_account', query: {} });
                    }
                    return;
                }
                next();
                // that.authPath(option, next);
            } else if (res.data.is_user == 0) { //未登录
                if (res.data.is_wechat_auth == 1) { //授权成功，未登录
                    tools.cache.set('isLogin', 0);
                    tools.cache.set('isAuth', 1);
                    // 判断是否是从登录页面的微信一键登录进来的
                    if (sessionStorage.getItem('wechat_login_tips')) {
                        next({ path: '/login', query: { callback: option.callbackUrl } });
                        return;
                    }
                    that.check(option, next);
                    return;
                } else if (/(^\/(goodsdetail_share))/i.test(option.url)) { //分享的链接，未登录
                    tools.cache.set('isLogin', 0);
                    tools.cache.set('isAuth', 0);
                    that.authPath(option, next);
                    return;
                } else if (res.data.is_wechat_auth == 0 || tools.cache.get('isAuth') == 0) { //授权失败
                    tools.cache.set('isAuth', 0);
                    tools.cache.set('isLogin', 0);

                    if (option.url == '/') {
                        that.check(option, next);
                    } else {
                        if (!!next) {
                            console.log('获取是否登录 loginStatus:365');
                            next({ path: '/login', query: { type: 2, is_wechat: 1, callback: option.callbackUrl }, replace: true });
                        } else {
                            tools.router.replace({ 'path': '/login', query: { type: 2, is_wechat: 1, callback: option.callbackUrl } });
                        }
                    }
                }
            }
        }
    },
}


// WEBPACK FOOTER //
// ./src/common/loginStatus.js